/** Visible h2 for My Tasks / History tab panels (distinct from tab strip labels). */
const MY_TASKS_HEADINGS = {
  exercise: 'My Exercises',
  questionnaire: 'My Questionnaires',
  education: 'My Education',
};

const HISTORY_HEADINGS = {
  exercise: 'Completed Exercises',
  questionnaire: 'Completed Questionnaires',
  education: 'Completed Education',
};

/**
 * @param {string} selectedTab — 'exercise' | 'questionnaire' | 'education'
 * @param {'myTasks' | 'history'} page
 */
export function taskTabPanelHeading(selectedTab, page) {
  const map = page === 'history' ? HISTORY_HEADINGS : MY_TASKS_HEADINGS;
  return map[selectedTab] || map.exercise;
}
